import React from 'react'

import useWindowDimensions from '../../hooks/useWindowDimensions'

interface IProps {
  label: string
  disabled?: boolean
  onClick: () => void
}

const MobileCalcButton = ({ label, disabled, onClick }: IProps) => {
  const { width } = useWindowDimensions()

  if (width > 767) {
    return <></>
  }

  return (
    <div className='csas-center calc-button mobile-only'>
      <button
        type='button'
        className='csas-click csas-click--dark-blue csas-click--long csas-mb-md'
        onClick={onClick}
        disabled={disabled}
      >
        {label}
      </button>
    </div>
  )
}

export default MobileCalcButton
